import { render, staticRenderFns } from "./CProductQuantity.vue?vue&type=template&id=a54d1468&"
import script from "./CProductQuantity.vue?vue&type=script&lang=js&"
export * from "./CProductQuantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports